<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Why are fees and deductions coming out?<Caret /></summary>
  <p>
    You retained us on a Conditional Fee Agreement. Under the terms of that agreement, Section 4 [‘Paying us’], we
    outlined, “If you win your claim, you pay our basic charges, our expenses and disbursements and a success fee
    together with the premium for any insurance you take out.” You will see on your Bill that we have agreed to waive our
    success fee and also reduce our basic charges to ensure you kept more of the compensation.
  </p>
</details>
